import { useContext, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { LoadingContext } from "../../../../../contexts/Loading/LoadingContext";
import { api, errorTreatment } from "../../../../../services/api";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import "../../style.css";
import { ChartBar } from "./chart";
import { AuthContext } from "../../../../../contexts/Authentication/AuthContext";

export interface Documents {
  data: {
    timeOnClient: {
      id: number;
      route: string;
      client: string;
      waitingTime: string;
      clientId: string;
      weight: number;
    }[];
    count: number;
    limit: string;
  };
}

export const ChartTimeOnClientDeliveries = () => {
  const { changeVisibility } = useContext(LoadingContext);
  const { shortToken , id, mode } = useParams();
  const { hasShortToken} = useContext(AuthContext);
  let routeDocuments: string;
  const [documents, setDocuments] = useState<Documents["data"]>({
    timeOnClient: [{ id: 0, clientId: "", route: "", client: "", waitingTime: "", weight: 0 }],
    count: 0,
    limit: "",
  });
  const [completeRequisition, setCompleteRequisition] = useState(false);

  if (hasShortToken) {
    routeDocuments = `/documents/timeOnClient?graphic_id=chartTimeOnClientDeliveries&short_token=${shortToken}&screen_id=${id}`;
  } else {
    routeDocuments = `/documents/timeOnClient?graphic_id=chartTimeOnClientDeliveries&screen_id=${id}`;
  }

  useEffect(() => {
    changeVisibility(true);
    const fetchData = async () => {
      try {
        await requisition();
      } finally {
        changeVisibility(false);
        setCompleteRequisition(true);
      }
    };
    fetchData();
    if (mode === "view") {
      const intervalId = setInterval(() => {
        requisition();
      }, 60000);
      return () => clearInterval(intervalId);
    }
  }, []);

  async function requisition() {
    return await api
      .get(routeDocuments)
      .then((documents: Documents) => {
        setDocuments(documents.data);
      })
      .catch((error) => {
        errorTreatment(error);
      });
  }

  return (
    <>
      {useMemo(() => {
        return (
          <>
            <div id="chart-time-on-client-deliveries" className="h100 w100">
              {completeRequisition ? (
                <ChartBar data={documents} />
              ) : (
                <LoadingGraphics />
              )}
            </div>
          </>
        );
      }, [documents, completeRequisition])}
    </>
  );
};
